import { Routes, Route } from 'react-router-dom';
import { Header } from './header/Header';
import wallpaper from "./assets/wallpaper.jpg";
import "./App.css";
import { Home } from './components/home/Home';
import { About } from './components/aboutus/About';
import { Contact } from './components/contact/Contact';
import { Individual } from './components/individual/Individual';
import { Child } from './components/child/Child';
import { Couple } from './components/couple/Couple';

function App() {
  return (
    <>
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services/individual" element={<Individual />} />
        <Route path="/services/child" element={<Child />} />
        <Route path="/services/couple" element={<Couple />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </>
    
  );
}

export default App;
